import styled from "styled-components"
import escudo from './assets/escudo.png'
import calendario from './assets/calendario.png'
import like from './assets/like.png'
import sino from './assets/sino.png'
import Card from '../../../components/CardPorqueNos'


const ContainerPrincipal = styled.div`
  
margin-top:100px;
text-align: center;
width: 100%;
height: 600px;
background-color: ${props => props.theme.cores.primaria};

@media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    margin-top:0px;
    margin-left: -15px;
    width: 100%;
    height: 900px;
  }
`

const Container = styled.section`
  display: flex;
  justify-content: space-between;
  text-align: center;
  margin-top: 130px;
  margin-left: 5%;
  width: 90%;
  //border: 2px solid red;

  /* Media query para telas maiores que 1500px */
  @media (min-width: 1500px) {
    width: 70%; /* ou o valor de largura que você preferir */
    margin-left: 19%;
  }

  @media (max-width: 768px) {
    display: grid;
  justify-content: space-between;
  text-align: center;
  margin-top: 20px;
  margin-left: 5%;
  width: 90%;
  }
`;





const Titulo = styled.h2`
font-weight: 400;
    margin-bottom: 60px;
    color: white;
    font-family: Titillium Web,sans-serif;
    font-size: 55px;
    line-height: 1em;
    max-width: 1150px;
    margin-right: auto;
    margin-left: auto;
    margin-top: 100px;

    @media (max-width: 768px) {
        margin-top: 50px;
        margin-bottom: 30px;
  }
`

const EspacoCard = styled.h2`


    @media (max-width: 768px) {
       margin-left: 15px;
        margin-bottom: 10px;
  }

  @media (max-width: 375px) {
    margin-left: -1px;
        margin-bottom: 10px;
    
    
  }
`


export default function Atividades() {
    return (
        <ContainerPrincipal>
            <Titulo>
                Por que
                <strong> nos escolher?</strong>
            </Titulo>
            <Container>
                <EspacoCard>
                    <Card
                        title="COMUNICAÇÃO DE EXCELÊNCIA"
                        description="Nossa comunicação é transparente e acessível, simplificando a complexidade jurídica e mantendo nossos clientes sempre informados."
                        imageUrl=""
                    />
                </EspacoCard>
                <EspacoCard>
                    <Card
                        title="VASTA EXPERIÊNCIA"
                        description="Com mais de 5 anos de atuação, a Alves Advocacia combina tradição e inovação para fornecer soluções jurídicas sólidas e estratégicas."
                        imageUrl=""
                    />
                </EspacoCard>
                <EspacoCard>
                    <Card
                        title="ESCRITÓRIO FULLSERVICE"
                        description="A Alves Advocacia oferece uma gama completa de serviços jurídicos, cobrindo todas as suas necessidades com uma equipe altamente qualificada."
                        imageUrl=""
                    />
                </EspacoCard>

            </Container>
        </ContainerPrincipal>
    )
}